module.exports = __webpack_public_path__ + "static/media/yesterdayImage2.1992a695.png";